(() => {
  if (window.__dbrlStoreContactReady) return;
  window.__dbrlStoreContactReady = true;
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[data-dbrl-store-call]') : null;
    if (!link || link.getAttribute('href') !== 'tel:+15617506744') return;
    const debug = window.Shopify?.theme?.id === 169044017241 && window.Shopify?.theme?.role === 'unpublished' && new URLSearchParams(location.search).get('dbrl_call_debug') === '20261022-review';
    // An explicitly opened draft QA session exercises the real link handler without dialing.
    if (debug) event.preventDefault();
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    const eventId = 'store-call-' + Array.from(bytes, b => b.toString(16).padStart(2,'0')).join('');
    const preview = Boolean(window.Shopify?.designMode || window.Shopify?.theme?.role === 'unpublished' || new URLSearchParams(location.search).has('preview_theme_id') || document.getElementById('preview-bar-iframe'));
    const detail = {stage:'click_to_call',page_path:location.pathname,placement:link.dataset.dbrlStoreCall,event_id:eventId,preview};
    document.dispatchEvent(new CustomEvent('dbrl:store-call-preview',{detail}));
    // Theme previews exercise the handler without sending production analytics.
    if (preview && !debug) return;
    window.Shopify?.analytics?.publish('dbrl:store_call',{...detail,...(debug ? {debug_mode:true,qa_theme:'169044017241'} : {})});
    console.info('DBRL store call published:',eventId,debug ? 'debug' : 'normal');
  });
})();
